// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j3EF","title":"styles_title__1kddH"};